import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from './axios';

const withMosadIsolation = (WrappedComponent) => {
  return (props) => {
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
    const { mosadToken } = useSelector((state) => state.user);

    if (!mosadToken) {
      return <Navigate to="/mosads" />;
    }

    // Add mosad token to all API calls
    const api = {
      get: async (url, config = {}) => {
        const response = await axios.get(url, config);
        return response.data;
      },
      post: async (url, data, config = {}) => {
        const response = await axios.post(url, data, config);
        return response.data;
      },
      put: async (url, data, config = {}) => {
        const response = await axios.put(url, data, config);
        return response.data;
      },
      delete: async (url, config = {}) => {
        const response = await axios.delete(url, config);
        return response.data;
      },
    };

    // const api = {
    //   get: async (url, config = {}) => {
    //     const response = await axios.get(url, {
    //       ...config,
    //       headers: {
    //         ...config.headers,
    //         'Authorization': token,
    //         'MosadAuthorization': mosadToken,

    //       },
    //     });
    //     return response.data;
    //   },
    //   post: async (url, data, config = {}) => {
    //     const response = await axios.post(url, data, {
    //       ...config,
    //       headers: {
    //         ...config.headers,
    //         'Authorization': token,
    //         'MosadAuthorization': mosadToken,
    //       },
    //     });
    //     return response.data;
    //   },
    //   put: async (url, data, config = {}) => {
    //     const response = await axios.put(url, data, {
    //       ...config,
    //       headers: {
    //         ...config.headers,
    //         'Authorization': token,
    //         'MosadAuthorization': mosadToken,
    //       },
    //     });
    //     return response.data;
    //   },
    //   delete: async (url, config = {}) => {
    //     const response = await axios.delete(url, {
    //       ...config,
    //       headers: {
    //         ...config.headers,
    //         'Authorization': token,
    //         'MosadAuthorization': mosadToken,
    //       },
    //     });
    //     return response.data;
    //   },
    // };

    return <WrappedComponent {...props} api={api} token={token} mosadToken={mosadToken} dispatch={dispatch} />;
  };
};

export default withMosadIsolation; 